import { Container } from "aurelia-dependency-injection";
import { observable, bindable } from "aurelia-framework";
import $ from "jquery";
//import Quill from 'quill';
import moment from "moment";
import "jquery-ui-dist";

export class VideoMessageBase {
  @observable cc = "";
  @observable bcc = "";
  @bindable picker;
  constructor(
    authService,
    userMessageService,
    router,
    apiBase,
    api,
    accountApi,
    envService,
    isAdmin = false
  ) {
    this.isAdmin = isAdmin;
    this.authService = authService;
    this.userMessageService = userMessageService;
    this.router = router;
    this.envService = envService;

    this.api = api;
    this.apiBase = apiBase;
    this.accountApi = accountApi;

    this.saving = false;
    this.sending = false;
    this.deleting = false;
    this.processingWait = false;

    this.editable = true;

    this.loading = true;

    this.app_name = "Magnfi";
    this.file_name = null;

    if (window.whitelabel) {
      this.app_name = window.app_name;
    }

    this.subjectMax = 64;
    this.bodyMax = 250;
    this.ctaLinkMax = 500;
    this.ctaTextMax = 20;

    this.showCustomFrameSave = false;

    this.firstName = "";
    this.lastName = "";

    this.showCustomImage = false;
    this.static = "static";
    this.active = "active";
    this.selectedFrameFlag = 0;

    this.param_user_id = "";
    this.param_subject = "";
    this.param_call_action_button = "";
    this.param_call_action_url = "";

    this.frameImgCustom = "";
    this.dateTimeValue = null;
    this.turnoffVideoEmail = true;
    this.previousVideo = 0;

    this.showDateTime = false;

    this.timestampDateTime = null;

    this.animationClass = "videoFrameImgmotionIphone";
    this.frameClass = "videoFrameImgIphone";
    this.playbuttonAccessClass = "";
    this.playbuttonClass = "";
    this.imageContainer = "";
    this.iphone_preset = 0;
    this.onresize = this.onresize.bind(this);

    this.subjectArray = [];
    this.ctaBtnArray = [];
    this.ctaUrlArray = [];

    this.instantPreviewShow = true;

    this.browserName = this.envService.browserDetails();
    this.browserAppVersion = navigator.appVersion;

    if (this.browserName.name == "Safari" && !this.envService.isMobile()) {
      this.instantPreviewShow = false;
    }
    this.dateEntered;
    this.sendLater = true;
    this.is_scheduled = 0;
    this.is_sent = 0;

    this.embed_code_start =
      '<iframe frameborder="0" scrolling="no" marginheight="0" marginwidth="0"width="600" height="400" type="text/html" src="';
    this.embed_code_end =
      '" ></iframe><a href="https://staging-output-test.s3.amazonaws.com/video_email/2030/processed.mp4">Video Email</a>';

    this.site_url = window.site_url;
    this.awsUrl = "";
    this.video_message_progress = true;
    this.video_message_status_message = "";

    // video recorder

    this.show_recorder = false;
    this.selected_screen = "ONLY_CAM";

    this.count = 0;
    this.cameraId = 0;
    this.products = [];
    this.deviceIds = [];
    this.products = [];
    this.deviceIdsAudio = [];
    this.productsAudio = [];
  }
  toggleSendLater() {
    this.sendLater = !this.sendLater;
  }

  pickerChanged() {
    this.picker.events.onHide = function (e) {
      this.picker.events.onShow = (e) => console.log("onShow");
      this.picker.events.onChange1 = function (e) {
        console.log("Changed Called");
      };
      this.picker.events.onChange = function (e) {
        console.log("onChange");
      };
      this.picker.events.onError = (e) => console.log("onError");
      this.picker.events.onUpdate = (e) => console.log("onUpdate");
    };
  }

  activate(params, route) {
    console.log("Activate");
    this.status = null;
    this.id = params.id;
    console.log("params in video message", params);
    var retrievedObject = localStorage.getItem("VideoEmailFileName");
    this.file_name = retrievedObject;
    localStorage.removeItem("VideoEmailFileName");
    this.account_owner_user_id = this.authService.getAccount().owner_user_id;
    this.current_account_data = this.authService.getAccount();
    this.turnofffReplyBack=true;

    if (this.id) {
      this.api.getById(
        this.id,
        this.authService.getUser().token,
        this.saveCustomFlag.bind(this),
        this.saveLoadError.bind(this)
      );
    }

    this.isOpenByAdmin = location.href.includes("/wladmin/user/"); //for hiding capture button when admin/wl creating video message for users
    this.firstName = this.current_account_data.first_name;
    this.lastName = this.current_account_data.last_name;
    this.showVideo = false;
    this.isMobile = this.envService.isMobile();
    this.video_src = "api/videoMessage/getUserVideo/"+localStorage.getItem('link_key');
    if (this.id) {
      this.api.getParams(
        this.authService.getUser().token,
        (params) => {
          for (let i = 0; i < params.video_email_fields.length; i++) {
            let subjectObj = {};
            let ctaUrlObj = {};
            let ctaBtnObj = {};
            subjectObj["id"] = i;
            subjectObj["name"] = params.video_email_fields[i].subject;
            ctaUrlObj["id"] = i;
            ctaUrlObj["name"] = params.video_email_fields[i].call_action_url;
            ctaBtnObj["id"] = i;
            ctaBtnObj["name"] = params.video_email_fields[i].call_action_button;
            this.subjectArray.push(subjectObj);
            this.ctaUrlArray.push(ctaUrlObj);
            this.ctaBtnArray.push(ctaBtnObj);
          }

          this.maxCopies = params.params.maxCopies;
          this.copiesLeft = this.maxCopies;
          this.load();
        },
        this.saveLoadError
      );
    }
  }

  attached() {
    console.log("attached");
    if (this.id) {
      console.log("attached", this.id);
      this.api.getParams(
        this.authService.getUser().token,
        (params) => {
          for (let i = 0; i < params.video_email_fields.length; i++) {
            let subjectObj = {};
            let ctaUrlObj = {};
            let ctaBtnObj = {};
            subjectObj["id"] = i;
            subjectObj["name"] = params.video_email_fields[i].subject;
            ctaUrlObj["id"] = i;
            ctaUrlObj["name"] = params.video_email_fields[i].call_action_url;
            ctaBtnObj["id"] = i;
            ctaBtnObj["name"] = params.video_email_fields[i].call_action_button;
            this.subjectArray.push(subjectObj);
            this.ctaUrlArray.push(ctaUrlObj);
            this.ctaBtnArray.push(ctaBtnObj);
          }

          this.maxCopies = params.params.maxCopies;
          this.copiesLeft = this.maxCopies;
          this.load();
        },
        this.saveLoadError
      );
    } else {
      this.reset();
      this.api.getParams(
        this.authService.getUser().token,
        (params) => {
          for (let i = 0; i < params.video_email_fields.length; i++) {
            let subjectObj = {};
            let ctaUrlObj = {};
            let ctaBtnObj = {};
            subjectObj["id"] = i;
            subjectObj["name"] = params.video_email_fields[i].subject;
            ctaUrlObj["id"] = i;
            ctaUrlObj["name"] = params.video_email_fields[i].call_action_url;
            ctaBtnObj["id"] = i;
            ctaBtnObj["name"] = params.video_email_fields[i].call_action_button;
            this.subjectArray.push(subjectObj);
            this.ctaUrlArray.push(ctaUrlObj);
            this.ctaBtnArray.push(ctaBtnObj);
          }
          this.maxCopies = params.params.maxCopies;
          this.copiesLeft = this.maxCopies;
        },
        this.saveLoadError
      );
    }
    this.videoMessageListt.activate();
    window.addEventListener("resize", this.onresize);

    $("#progressbar").progressbar({
      value: false,
      change: function () {
        $(".progress-label").text($("#progressbar").progressbar("value") + "%");
      },
      complete: function () {
        $(".progress-label").text("Complete!");
      },
    });

    this.gotDevices();
  }

  progress() {
    var val = $("#progressbar").progressbar("value") || 0;
    console.log("Calling progress bar...." + val);
    console.log(
      "status " + this.status + " elastic status " + this.elastic_transcoder
    );

    $("#progressbar").progressbar("value", val + 1);

    if (val < 99) {
      console.log("Recursive calling of progress " + val);
      //setTimeout( this.progress.bind(this), 3000 );
      setTimeout(this.progress.bind(this), 12000);
    }
  }

  detached() {
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
      this.refreshTimeout = null;
    }
    clearTimeout(this.refreshTimeout);
    this.refreshTimeout = null;
    clearTimeout(this.timeoutFunction);
    this.timeoutFunction = null;

    window.removeEventListener("resize", this.onresize);
  }

  reset() {
    this.status = 0;
    this.status_text = "New";

    this.subject = "";
    this.cta_link = null;
    this.cta_link_text = null;
    this.cta_phone_link = null;
    this.editable = true;

    this.subjectKeyUp();
    this.ctaLinkKeyUp();
    this.ctaTextKeyUp();

    this.elastic_transcoder = false;
  }

    downloadSubmittedvideo(){
      console.log(this.authService.getUser())
          window.open('api'+(this.authService.getUser().role=="ADMIN"?'/admin':'')+'/videoMessage/getMessageVideo/' + this.id + '?Authorization=' + this.authService.getUser().token + '&t=' + new Date(), "_blank")
      }


    captureScreen(flag = false) {
      if (this.validate()) {
        // this.saving = false;
        this.api.save(
          this.getData(),
          this.authService.getUser().token,
          (data) => {
            this.setData(data);

            var magni_recorder=JSON.stringify({
              capture_key: this.authService.getAccount().link_id,
              video_id: this.id,
              upload: false,
              video_email: false,
              portrait: false,
              is_branded_video: false,
              video_message: true,
            })
            sessionStorage["magnfi_captureKey"] =
              this.authService.getAccount().link_id;

            if (!flag) {
              localStorage.setItem("magni_screen", this.selected_screen);
              localStorage.setItem("magni_recorder", magni_recorder);

              let w = 840,
                h = 680;
              var left = screen.width / 2 - w / 2;
              var top = screen.height / 2 - h / 2;

              window.open(
                "/screen-recorder/build/index.html?magni_screen="+this.selected_screen+"&magni_recorder="+magni_recorder+"&magnfi_captureKey="+this.authService.getAccount().link_id+"&token="+localStorage.getItem('token')+"&magni_v_device_id="+localStorage.getItem('magni_v_device_id')+"&magni_a_device_id="+localStorage.getItem('magni_a_device_id'),
                "_blank",
                `toolbar=yes,scrollbars=tes,resizable=yes,top=${top},left=${left},width=${w},height=${h}`
              );

            } else
              this.router.navigate(
                "#/capture/video/message/" +
                  this.id +
                  "?captureType=5" +
                  "?videoUpload=1"
              );
          },
          this.saveLoadError.bind(this)
        );
      }
    }

    datetimechanged() {
        let datetimeformat = new Date(this.dateTimeValue).toISOString();
        let datetimefor = moment.utc(datetimeformat).format('M/D/YYYY h:mm:ss A');
        var expires = moment.utc(datetimefor).valueOf()/1000;
        this.timestampDateTime = expires;
        console.log("date time changed", datetimefor,expires);
    }

    sendLater() {
        this.showDateTime = !this.showDateTime;
    }
    load(processingWait = false) {
        setTimeout( this.progress.bind(this), 12000 );
        console.log("date time", this.dateTimeValue);
        if(processingWait) {
            this.api.getById(
                this.id,
                this.authService.getUser().token,
                (data) => {
                    this.status = data.status;
                    console.log("load function", this.status);
                    if(data.status == 1 || data.status == 2) {
                        setTimeout(this.load.bind(this), 5000, true);
                    } else {
                        document.getElementById('instantPreview').pause();
                        this.animateGif = this.apiBase + "/videoMessage/getUserFrame/" + this.link_key + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();
                        this.frame_src = this.apiBase + "/videoMessage/getUserAnimation/" + this.link_key + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();
                        console.log("re-process", this.animateGif, this.frame_src);
                        this.frame_src_url = this.site_url+"/"+this.frame_src;
                        this.loadTracking();

                    }

                    if(data.status == 3){
                        //video ready for preview
                        console.log('Video ready setting the progress bar balue to 100%')
                        $("#progressbar").progressbar( "value", 100);//val = 99;
                    }
                },
                this.saveLoadError.bind(this));
        } else {
            this.api.getById(
                this.id,
                this.authService.getUser().token,
                this.saveLoadSuccess.bind(this),
                this.saveLoadError.bind(this));

            this.loadTracking();
                // this.api.getStatsById(
                //     this.id,
                //     this.authService.getUser().token,
                //     this.saveStatsSuccess.bind(this),
                //     this.saveLoadError.bind(this));
                
        }

        this.api.getVideo(this.link_key,this.authService.getUser().token, (data) => {

            if(typeof(data) === "object" && data.hasOwnProperty("video_url")) {

                this.awsUrl = data.video_url;
            };

            if(typeof(data) === "object" && data.hasOwnProperty("gif_url")) {

                this.gif_url = data.gif_url;
            };

            if(typeof(data) === "object" && data.hasOwnProperty("custom_url")) {

                this.custom_url = data.custom_url;
            };
        },()=> {
            console.log("error aws");
        });

        console.log(this.awsUrl + " <----- AwsUrl Load function");

    }

    loadTracking() {
        this.api.getStatsById(
            this.id,
            this.authService.getUser().token,
            this.saveStatsSuccess.bind(this),
            this.saveLoadError.bind(this));
    }
    getGMTDatetime(){
        //https://stackoverflow.com/questions/26392280/using-momentjs-to-convert-date-to-epoch-then-back-to-date
        if(1){
            //get the timestamp of date entered in miliseconds
            var timestamp_miliseconds = moment(this.dateEntered, "MM-DD-YYYY hh:mm a").valueOf();
            //convert the timestamp into utc/gmt date time
            //var local_gmt_timestamp = moment.utc(timestamp_miliseconds).format('MM-DD-YYYY hh:mm a');
            //convert back the utc/gmt time into timestamp
            //var gmt_time = moment(local_gmt_timestamp, 'MM-DD-YYYY hh:mm a').valueOf();
            //console.log('GMT TIMESTAMP, GMT DATE TIME >>>>>>> <<<<<<< ', gmt_time, local_gmt_timestamp);
            return timestamp_miliseconds/1000; //convert back to seconds from miliseconds
        }
        if(0){

            var timestamp_miliseconds = moment(this.dateEntered, "MM-DD-YYYY hh:mm a").valueOf();
            //Get gmt offset
            var d = new Date();
            var gmt_off_set_minutes = d.getTimezoneOffset();
            var gmt_off_set_miliseconds = gmt_off_set_minutes * 60 * 1000;
            //var local_gmt_timestamp = timestamp_miliseconds + gmt_off_set_miliseconds;
            var gmt_time = moment(local_gmt_timestamp).format("MM-DD-YYYY hh:mm a");
            console.log('GMT TIMESTAMP, GMT DATETIME ', local_gmt_timestamp , gmt_time );
            return local_gmt_timestamp;
        }

    }

    save() {

        if (this.validate()) {
            this.saving = true;
            this.api.save(
                this.getData(),
                this.authService.getUser().token,
                this.saveLoadSuccess.bind(this),
                this.saveLoadError.bind(this));
        }
    }

    successGetUserData(data) {
        this.firstName = data.first_name ? data.first_name : null;
        this.lastName = data.last_name ? data.last_name : null;


    }

    saveCustomFlag(data) {
            console.log("stats data",data);
            //this.status = data.status;
            this.showCustomImage = data.selected_frame == null ? true : false;
            if(this.showCustomImage == true) {
                this.frameImgCustom = "videoFrameImgCustom";
                // this.showCustomImage = true;
                        // this.static = "customImage";
                        // this.active = "";
                        // this.webStyle = "";
            }
            else {
                this.frameImgCustom = "";
            // this.webStyle = this.isMobile ? "" : "top: -145px; position: relative;";
            }
    }

    errorGetUserData(data) {

    }

    saveStatsSuccess(data) {
        console.log("data video message",data);
        this.setStats(data);
        if(this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
        this.refreshTimeout = setTimeout(this.loadTracking.bind(this), 5000);

    }

    saveLoadSuccess(data) {

        console.log("saveLoadSuccess");
        this.setData(data);



        if(data.status == 1 || data.status == 2) {
            setTimeout(this.load.bind(this), 5000, true);
        }

        if (this.saving)
            this.userMessageService.setUserMessage("user", "Saved!");
        if (this.sending) {

            let msg = 'Sent!';
            if(data.gmt_time !== null && data.gmt_time != 0 && data.gmt_time != ''){
                msg = 'Saved!';
            }
            //console.log(' ..... ', msg, data.gmt_time);
            //return;
            //this.userMessageService.setUserMessage("user", "Sent!");
            this.userMessageService.setUserMessage("user", msg);
            const vidoePage = window.location.href;
            if(vidoePage.includes("user"))
            {
                console.log("window.site_url...user")
                this.router.navigate(window.site_url+'#/user'+'/videos');
            }

            else if(vidoePage.includes("wladmin"))
            {
                console.log("window.site_url...wladmin")
                this.router.navigate(window.site_url+'#/wladmin'+'/videos');
            }

            else if(vidoePage.includes("admin"))
            {
                console.log("window.site_url...admin")
                this.router.navigate(window.site_url+'#/admin'+'/videos');
            }
        }
        if (this.deleting)
            this.userMessageService.setUserMessage("user", "Deleted!");
        this.sending = false;
        this.saving = false;
        this.deleting = false;
        console.log("window.site_url...1",window.site_url,"...",data);
        if(data.status==200 || data.status==201)
        {
            const vidoePageSite = window.location.href;
            if(vidoePageSite.includes("user"))
            {
                console.log("window.site_url...user:"+window.site_url+'#/user'+'/videos');
                this.router.navigate(window.site_url+'#/user'+'/videos');
            }

            else if(vidoePageSite.includes("wladmin"))
            {
                console.log("window.site_url...wladmin")
                this.router.navigate(window.site_url+'#/wladmin'+'/videos');
            }

            else if(vidoePageSite.includes("admin"))
            {
                console.log("window.site_url...admin")
                this.router.navigate(window.site_url+'#/admin'+'/videos');
            }


        }

    }

    saveLoadSuccessDelete(data)
    {
        this.sending = false;
        this.saving = false;
        this.deleting = false;
        console.log("window.site_url...1",window.site_url,"...",data);
        if(data.status==200 || data.status==201)
        {
            const vidoePageSite = window.location.href;
            if(vidoePageSite.includes("user"))
            {
                console.log("window.site_url...user:"+window.site_url+'#/user/video/message');
                this.router.navigate(window.site_url+'#/user/video/message');
            }

            else if(vidoePageSite.includes("wladmin"))
            {
                console.log("window.site_url...wladmin")
                this.router.navigate(window.site_url+'#/wladmin'+'/videos');
            }

            else if(vidoePageSite.includes("admin"))
            {
                console.log("window.site_url...admin")
                this.router.navigate(window.site_url+'#/admin'+'/videos');
            }

            this.userMessageService.setUserError("user", "Deleted!");
        }

    }

    saveLoadError(msg) {

        this.sending = false;
        this.saving = false;
        this.deleting = false;
        this.userMessageService.setUserError("user", msg);

    }

    checkheight() {

         this.timeoutFunction = setTimeout(function() {
            this.checkheight();
          }.bind(this), 1000);
        let heightVideo2 = $(document.getElementById("animationVideoEmail")).height();
        let widthVideo2 = $(document.getElementById("animationVideoEmail")).width();
        if(heightVideo2 < widthVideo2 && this.iphone_preset == 1) {
            this.playbuttonAccessClass = "playButton-access-iphone-landscape";
            this.playbuttonClass = "playButton-iphone-landscape";
        }
        if(heightVideo2 > widthVideo2 && this.iphone_preset == 1) {
            this.playbuttonAccessClass = "playButton-access-iphone";
            this.playbuttonClass = "playButton-iphone";
        }
        console.log("video height compose", heightVideo2,widthVideo2);
    }
    setStats(data) {
        this.videoStats = data.tracking_details ? data.tracking_details : "";

            //this.animationClass = (data.video_details.iphone_preset && data.video_details.iphone_preset == 1) ? "videoFrameImgmotionIphone" : "videoFrameImgmotion";
            //this.frameClass = (data.video_details.iphone_preset && data.video_details.iphone_preset == 1) ? "videoFrameImgIphone" : "videoFrameImg";
            this.animationClass = (data.video_details.iphone_preset && data.video_details.iphone_preset == 1) ? "videoFrameImgmotion" : "videoFrameImgmotion";
            this.frameClass = (data.video_details.iphone_preset && data.video_details.iphone_preset == 1) ? "videoFrameImg" : "videoFrameImg";
            if(this.iphone_preset == 0) {
            this.playbuttonAccessClass = (data.video_details.iphone_preset && data.video_details.iphone_preset == 1) ? "playButton-access-iphone" : "playButton-access";
            this.playbuttonClass = (data.video_details.iphone_preset && data.video_details.iphone_preset == 1) ? "playButton-iphone" : "playButton";
            }
            this.imageContainer = (data.video_details.iphone_preset && data.video_details.iphone_preset == 1) ? "image-container-iphone" : "";
            this.iphone_preset = (data.video_details.iphone_preset && data.video_details.iphone_preset == 1) ? 1 : 0 ;
            if(data.video_details.selected_frame == null) {
                this.frameClass = "";
            }
            if(data.video_details.status == 1 || data.video_details.status == 2 || data.video_details.status == 3){
              console.log('check status 1,2,3', data.video_details.status);
              this.video_message_progress = true;
              if(data.video_details.status == 3){
                  this.video_message_progress = false;
              }
            }
            console.log("video classes", this.animationClass, this.frameClass, this.playbuttonClass);

        console.log("video stats value", data, "...", this.videoStats);
    }

    setData(data) {
        console.log('???????');
        console.log(data);

        this.onresize();
        this.id = data.id;
        this.account_owner_user_id = data.account_owner_user_id;
        this.status = data.status;
        console.log("setData function", this.status);
        this.status_text = data.status_text;
        this.is_scheduled = data.is_scheduled;
        this.is_sent = data.is_sent;
        if(this.is_scheduled && !this.is_sent){
            this.sendLater = false;
            //this.status_text = moment(data.status_text).format("MM-DD-YYYY hh:mm a");
            //this.status_text =  moment(data.status_text * 1000).format('MM/DD/YYYY hh:mm A');

        }

        this.subject_title = data.subject;
        this.subject = data.subject;
        this.selected_frame = data.selected_frame;
        this.total_frames = data.total_frames;

        this.cta_link = data.cta_link;
        this.cta_link_text = data.cta_link_text;
        this.cta_phone_link = data.cta_phone_link;
        this.link_key = data.link_key;
        this.short_code = data.short_code;
        this.turnoffVideoEmail = !data.video_played_notification;
        this.turnoffReplyBack = data.remove_reply_back;
        this.previousVideo = data.elastic_transcoder;
        this.elastic_transcoder = data.elastic_transcoder;
        localStorage.setItem('link_key',data.link_key)

         if(data.gmt_time !== null && data.gmt_time != 0 && data.gmt_time != ''){
             this.dateEntered = moment(data.gmt_time * 1000).format('MM/DD/YYYY hh:mm A');
         } else {
             this.dateEntered = moment().format('MM/DD/YYYY hh:mm A');
         }


        this.animateGif = this.apiBase + "/videoMessage/getUserFrame/" + this.link_key  + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();

        this.frame_src = this.apiBase + "/videoMessage/getUserAnimation/" + this.link_key + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();
        console.log("re-process", this.animateGif, this.frame_src, this.previousVideo);
        this.frame_src_url = this.site_url+"/"+this.frame_src;

        this.processing_failed = data.processing_failed || false;
        this.editable = this.status < 200;

        console.log(this.link_key +" <-------- Key");
        console.log(this.authService.getUser().token + " <----- Token");

        this.api.getVideo(this.link_key,this.authService.getUser().token, (data) => {

            if(typeof(data) === "object" && data.hasOwnProperty("video_url")) {

                this.awsUrl = data.video_url;
            };

            if(typeof(data) === "object" && data.hasOwnProperty("gif_url")) {

                this.gif_url = data.gif_url;
            };

            if(typeof(data) === "object" && data.hasOwnProperty("custom_url")) {

                this.custom_url = data.custom_url;
            };
        },()=> {
            console.log("error aws");
        });

        console.log(this.awsUrl + " <----- AwsUrl");

        //this.bodyEditor.enable(this.editable);

        this.subjectKeyUp();
        this.ctaLinkKeyUp();
        this.ctaTextKeyUp();

        if(this.elastic_transcoder > 0)
        {
          console.log('this status', this.status ,'=======','this video message progress', this.video_message_progress);
            if(this.status == 1 || this.status == 2 || this.status == 3){
                //Step-1: Recording, Preview, Watermarking
                //this.video_message_status_message = "Video getting ready to create, pick your call to action and music for your video";
                this.video_message_progress = true;
                if(this.status == 3){
                    this.video_message_progress = false;
                    //this.video_message_status_message = "Video ready, pick your call to action and music for your video";
                }
            }
            if(this.status == 100){
                this.video_message_progress = false;
                this.video_message_status_message = "";
            }
        }
    }

    emailnotify() {
        console.log("email notify", this.turnoffVideoEmail);
        var data = {
            "video_id": this.id,
            "video_played_notification": this.turnoffVideoEmail ?  0 : 1
        }

        this.api.updateVideoPlayedNotification(data, this.authService.getUser().token, (data) => {
            console.log("email notify data 1",data);

           if(data.video_played_notification == 0) {
            this.userMessageService.setUserMessage("user", "Played Notifications turned on");

           }
           else if (data.video_played_notification == 1) {
            this.userMessageService.setUserMessage("user", "Played Notifications turned off");
           }
        },
        () => {
            this.userMessageService.setUserMessage("user", "Error");

        })

    }

    removeReplyBack() {

          var data = {
            "video_id": this.id,
            "remove_reply_back": this.turnoffReplyBack
          }

        this.api.updateRemoveReplyBack(data, this.authService.getUser().token, (data) => {
            console.log("email notify data 1",data);

          if(data.video_played_notification == 0) {
            this.userMessageService.setUserMessage("user", "Remove Reply Back turned on");

          }
          else if (data.video_played_notification == 1) {
            this.userMessageService.setUserMessage("user", "Remove Reply Back turned off");
          }
        },
        () => {
            this.userMessageService.setUserMessage("user", "Error");

        })


    } 

    getData() {

        if(this.cta_link != null && this.cta_link.length > 0 && (!this.cta_link.startsWith("http://") && !this.cta_link.startsWith("https://"))) {
            this.cta_link = "http://" + this.cta_link;
        }
        let portrait = localStorage.getItem("portrait");
        // localStorage.removeItem("portrait");
        //this.getGMTDatetime();
        var data = {
            "id": this.id || null,
            "account_owner_user_id": this.account_owner_user_id,
            "subject": this.subject,
            "selected_frame": this.selected_frame,
            "cta_link": this.cta_link,
            "cta_link_text": this.cta_link_text,
            "cta_phone_link": this.cta_phone_link,
            "firstName" : this.firstName,
            "lastName" : this.lastName,
            "gmt_time"  : (this.sendLater) ? '' : this.getGMTDatetime(),
            "iphone_video" :  portrait
        }
        console.log("send message data",data);
        return data;
    }


    send() {
        console.log("firstLastName",this.firstName, this.lastName);
        if (this.validate()) {
            this.sending = true;
            this.api.sendVideoEmail(
                this.getData(),
                this.authService.getUser().token,
                this.saveLoadSuccess.bind(this),
                this.saveLoadError.bind(this));
        }
    }

    capture(flag=false) {
        if (this.validate()) {
            this.saving = true;
            this.api.save(
                this.getData(),
                this.authService.getUser().token,
                (data) => {
                    this.setData(data);
                    sessionStorage['magnfi_captureKey'] = this.authService.getAccount().link_id;
                    if(!flag)
                    this.router.navigate("#/capture/video/message/" + this.id + "?captureType=5");
                    else
                    this.router.navigate("#/capture/video/message/" + this.id + "?captureType=5" + "?videoUpload=1&user_id="+this.account_owner_user_id);

                },
                this.saveLoadError.bind(this));
        }
    }




    validate() {
        var pass = true;

        if (this.subject == null || this.subject.trim() == '') {
            this.userMessageService.setUserError("user", "Subject is empty");

            pass = false;
        }

        return pass;
    }

    is_email(email)
    {
        var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailReg.test(email);
    }



    delete() {
        if (confirm("Are you sure you want to delete this video?")) {
            this.saving = true;
            this.deleting = true;
            this.api.deleteVideo(
                this.getData(),
                this.authService.getUser().token,
                this.saveLoadSuccessDelete.bind(this),
                this.saveLoadError.bind(this));
        }
    }



    subjectKeyUp() {

        var len = this.subject == null ? 0 : this.subject.length;

        if (len > this.subjectMax) {
            this.subject = this.subject.substring(0, this.subjectMax);
        } else {
            this.subjectCharsLeft = this.subjectMax - len;
        }

    }



    frameUp() {
        if(this.selected_frame === null || this.selected_frame == this.total_frames - 1) {
            this.selected_frame = 0;
        } else {
            this.selected_frame++;
        }

       this.api.setFrame(this.getData(),
            null,
            this.authService.getUser().token,
            () => {
                this.frame_src = this.apiBase + "/videoMessage/getUserFrame/" + this.link_key + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();
            },
            this.saveLoadError.bind(this));

    }

    frameDown() {
        if(this.selected_frame === null || this.selected_frame === 0) {
            this.selected_frame = this.total_frames - 1;
        } else {
            this.selected_frame--;
        }

        this.api.setFrame(this.getData(),
        null,
        this.authService.getUser().token,
        () => {
            this.frame_src = this.apiBase + "/videoMessage/getUserFrame/" + this.link_key + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();
        },
        this.saveLoadError.bind(this));


    }

    saveCustomFrame() {
        if(this.custom_frame_files && this.custom_frame_files.length > 0) {
            this.selected_frame = null;
            this.api.setFrame(this.getData(),
                this.custom_frame_files[0],
                this.authService.getUser().token,
                () => {
                    this.animateGif = "api/videoMessage/getUserFrame/" + this.link_key  + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();
                    this.userMessageService.setUserMessage("user", "Image Uploaded!");
                    this.showCustomImage = true;
                    this.static = "customImage";
                    this.active = "";
                    this.webStyle = "";
                    this.frameImgCustom = "videoFrameImgCustom";
                    //location.reload();

                    this.api.getVideo(this.link_key,this.authService.getUser().token, (data) => {

                        if(typeof(data) === "object" && data.hasOwnProperty("custom_url")) {

                            this.custom_url = data.custom_url;
                        };
                    },()=> {
                        console.log("error aws");
                    });
                },
                this.saveLoadError.bind(this));
        }
    }

    removeCustomFrame() {
        // if(this.custom_frame_files && this.custom_frame_files.length > 0) {
            this.selected_frame = null;
            this.api.deleteCustomPreview(this.getData().id,
                // this.custom_frame_files[0],
                // this.authService.getUser().token,
                () => {
                    this.animateGif = this.apiBase + "/videoMessage/getUserFrame/" + this.link_key  + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();
                    this.frame_src = this.apiBase + "/videoMessage/getUserAnimation/" + this.link_key + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();
                    this.userMessageService.setUserMessage("user", "Image Removed!");
                    this.showCustomImage = false;
                    this.static = "static";
                    this.active = "active";
                    this.webStyle = this.isMobile ? "" : "top: -145px; position: relative;";
                    this.frameImgCustom = "";
                    //location.reload();
                },
                this.saveLoadError.bind(this));

        // }
    }

    openVideoPage() {
        window.open('#/message/' + this.link_key+"?token="+localStorage.getItem('token'), "_blank");
    }

    onresize() {
        var width = window.innerWidth - 100;

        // if(width > 288 && width < 500)
        //     this.bodyContainer.style.width = width + "px";
        // else {
        //     if(width <= 288)
        //     this.bodyContainer.style.width = "288px";
        //     else
        //     this.bodyContainer.style.width = "";
        // }
    }

    ctaLinkKeyUp() {
        var len = this.cta_link == null ? 0 : this.cta_link.length;

        if (len > this.ctaLinkMax) {
            this.cta_link = this.cta_link.substring(0, this.ctaLinkMax);
        } else {
            this.ctaLinkCharsLeft = this.ctaLinkMax - len;
        }
    }

    ctaTextKeyUp() {
        var len = this.cta_link_text == null ? 0 : this.cta_link_text.length;

        if (len > this.ctaTextMax) {
            this.cta_link_text = this.cta_link_text.substring(0, this.ctaTextMax);
        } else {
            this.ctaTextCharsLeft = this.ctaTextMax - len;
        }
    }

    ccChanged(newValue, oldValue) {

        this.copiesLeft = this.maxCopies - this.getEmailListCount(this.cc) - this.getEmailListCount(this.bcc);

        if(this.copiesLeft < 0) {

            setTimeout(() => {
                this.cc = oldValue;
            },1);

        }

    }

    bccChanged(newValue, oldValue) {

        this.copiesLeft = this.maxCopies - this.getEmailListCount(this.cc) - this.getEmailListCount(this.bcc);

        if(this.copiesLeft < 0) {

            setTimeout(() => {
                this.bcc = oldValue;
            },1);
        }

    }

    validateEmailList(list) {
        if(list == null || list.trim() == '')
            return true;
        let emails = list.split(",");


        let result =  emails.filter(email => email.trim().length > 0 && !this.is_email(email.trim()));


        return result.length == 0;
    }

    getEmailListCount(list) {
        if(list == null || list.trim() == '')
            return 0;
        let emails = list.split(",");


        let result =  emails.filter(email => email.trim().length > 0);


        return result.length;
    }

    copyEmbedCode()
    {
        var url = this.site_url+"/w?v="+this.short_code;
        //var url = this.site_url+"/#/email/"+this.link_key+"_0";
        this.copyTextToClipboard(url);
        //this.userMessageService.setUserMessage('user', 'Copied!');
        document.getElementById("copy_msg2").style.display = "block";
	    setTimeout(function(){ document.getElementById("copy_msg2").style.display = "none"; }, 2000);
    }

    copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(
      function () {
        console.log("Async: Copying to clipboard was successful!");
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      }
    );
  }

  fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
      console.log("Fallback: Copying text command was " + msg);
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
  }

  copyHTMLEmbedCode() {
    var str = this.awsUrl;
    function listener(e) {
      e.clipboardData.setData("text/html", str);
      e.clipboardData.setData("text/plain", str);
      e.preventDefault();
    }
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
    this.userMessageService.setUserMessage("user", "Copied!");
  }

  copyHTML() {
    // if(navigator.platform.toUpperCase().indexOf('MAC') >= 0)
    //     this.copyToClipboard();
    // else
    this.copyURLThumbnailCode();
  }

  copyURLThumbnailCode() {
    var str = document.getElementById("url_thumbnail").innerHTML;
    function listener(e) {
      e.clipboardData.setData("text/html", str);
      e.clipboardData.setData("text/plain", str);
      e.preventDefault();
    }
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
    //this.userMessageService.setUserMessage('user', 'Copied!');
    document.getElementById("copy_msg1").style.display = "block";
    setTimeout(function () {
      document.getElementById("copy_msg1").style.display = "none";
    }, 2000);
  }

  copyToClipboard() {
    let textarea;
    let result;
    var string = document.getElementById("url_thumbnail").innerHTML;
    try {
      textarea = document.createElement("textarea");
      textarea.setAttribute("readonly", true);
      textarea.setAttribute("contenteditable", true);
      textarea.style.position = "fixed"; // prevent scroll from jumping to the bottom when focus is set.
      textarea.value = string;

      document.body.appendChild(textarea);

      textarea.focus();
      textarea.select();

      const range = document.createRange();
      range.selectNodeContents(textarea);

      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);

      textarea.setSelectionRange(0, textarea.value.length);
      result = document.execCommand("copy");
    } catch (err) {
      console.error(err);
      result = null;
    } finally {
      document.body.removeChild(textarea);
    }

    // manual copy fallback using prompt
    if (!result) {
      const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
      const copyHotkey = isMac ? "⌘C" : "CTRL+C";
      result = prompt(`Press ${copyHotkey}`, string); // eslint-disable-line no-alert
      if (!result) {
        return false;
      }
    }
    //return true;
    this.userMessageService.setUserMessage("user", "Copied!");
  }

  toggleShowModal() {
    if (!this.show_recorder) {
      if (!this.validate()) {
        return;
      }
    }

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.capture(false);
      return;
    }

    // if(this.show_recorder){
    //   this.show_recorder=!this.show_recorder
    // }else{

    navigator.permissions
      .query({ name: "camera" })
      .then(
        function (result) {
          if (result.state === "prompt") {
            navigator.mediaDevices
              .getUserMedia({ audio: true, video: true })
              .then(
                function () {
                  this.gotDevices();
                  this.show_recorder = !this.show_recorder;
                }.bind(this)
              );
          } else if (result.state === "granted") {
            this.gotDevices();
            this.show_recorder = !this.show_recorder;
          } else if (result.state === "denied") {

            this.userMessageService.setUserError(
              "user",
              "Please Allow Camera and Microphone permission"
            );
          }
        }.bind(this)
      )
      .catch(
        function () {
          console.log("before error");

          navigator.mediaDevices
            .getUserMedia({ audio: true, video: true })
            .then(
              function () {
                this.gotDevices();
                this.show_recorder = !this.show_recorder;
              }.bind(this)
            )
            .catch(
              function () {
                this.userMessageService.setUserError(
                  "user",
                  "Please Allow Camera and Microphone permission"
                );
              }.bind(this)
            );
        }.bind(this)
      );

    // }
  }

  startVideoCapture(){

    if (this.validate()) {
    if(this.selected_screen==='ONLY_CAM'){

      this.capture(false)


    }else{
      this.captureScreen(false)
    }

    localStorage.setItem('magni_v_device_id',this.camera)
    localStorage.setItem('magni_a_device_id',this.audio)

    this.show_recorder=false;
  }
}
  updateScreen(screen){

    this.selected_screen=screen

  }

  gotDevices() {
    navigator.permissions
      .query({ name: "camera" })
      .then(
        function (result) {
          console.log(result.state);

          this.products = [];
          this.deviceIdsAudio = [];
          this.productsAudio = [];

          if (result.state === "granted") {
            navigator.mediaDevices.enumerateDevices().then(
              function (devices) {
                let products = [];
                let deviceIds = [];
                let deviceIdsAudio = [];
                let productsAudio = [];

                devices.forEach(function (device) {
                  console.log("=================================");
                  console.log("devices=>", device);
                  console.log("camera kind ", device.kind);
                  console.log("camera label ", device.label);
                  console.log("camera id ", device.deviceId);
                  console.log("=================================");
                  if (device.kind == "videoinput") {
                    //let temp = {};
                    let temp = { id: device.deviceId, name: device.label };
                    products.push(temp);
                    deviceIds.push(device.deviceId);
                  } else if (device.kind == "audioinput") {
                    let temp = { id: device.deviceId, name: device.label };
                    productsAudio.push(temp);
                    deviceIdsAudio.push(device.deviceId);
                  }

                  // data.push(device.kind + ":*** " + device.label + " id** = " + device.deviceId);
                });
                this.products = products;
                this.deviceIds = deviceIds;
                this.productsAudio = productsAudio;
                this.deviceIdsAudio = deviceIdsAudio;

                console.log(
                  " Devices Ids gotDevices",
                  JSON.stringify(deviceIds)
                );
                this.selectedProductId = this.deviceIds[0];
                this.selectedProductIdAudio = this.deviceIdsAudio[0];
                this.camera = this.deviceIds[0];
                this.audio = this.deviceIdsAudio[0];

                //this.openMediaStream();
                // this.reportLogMessage({ msg: "UserDevices: " + JSON.stringify(data) });
              }.bind(this)
            );

            //permission has already been granted, no prompt is shown
          } else if (result.state === "prompt") {
            // navigator.mediaDevices
            //   .getUserMedia({ audio: true, video: true })
            //   .then(
            //     function () {


                  navigator.mediaDevices.enumerateDevices().then(
                    function (devices) {
                      let products = [];
                      let deviceIds = [];
                      let deviceIdsAudio = [];
                      let productsAudio = [];

                      devices.forEach(function (device) {
                        console.log("=================================");
                        console.log("devices=>", device);
                        console.log("camera kind ", device.kind);
                        console.log("camera label ", device.label);
                        console.log("camera id ", device.deviceId);
                        console.log("=================================");
                        if (device.kind == "videoinput") {
                          //let temp = {};
                          let temp = {
                            id: device.deviceId,
                            name: device.label,
                          };
                          products.push(temp);
                          deviceIds.push(device.deviceId);
                        } else if (device.kind == "audioinput") {
                          let temp = {
                            id: device.deviceId,
                            name: device.label,
                          };
                          productsAudio.push(temp);
                          deviceIdsAudio.push(device.deviceId);
                        }

                        // data.push(device.kind + ":*** " + device.label + " id** = " + device.deviceId);
                      });
                      this.products = products;
                      this.deviceIds = deviceIds;
                      this.productsAudio = productsAudio;
                      this.deviceIdsAudio = deviceIdsAudio;

                      console.log(
                        " Devices Ids gotDevices",
                        JSON.stringify(deviceIds)
                      );
                      this.selectedProductId = this.deviceIds[0];
                      this.selectedProductIdAudio = this.deviceIdsAudio[0];
                      this.camera = this.deviceIds[0];
                      this.audio = this.deviceIdsAudio[0];

                      //this.openMediaStream();
                      // this.reportLogMessage({ msg: "UserDevices: " + JSON.stringify(data) });
                    }.bind(this)
                  );
                // }.bind(this)
              // ).catch(function(){

              //       this.userMessageService.setUserError(
              //         "user",
              //         "Please Allow Camera and Microphone permission"
              //       );
              //     }.bind(this)
              // );

            //  there's no peristent permission registered, will be showing the prompt
          } else if (result.state === "denied") {
            //permission has been denied

            // this.userMessageService.setUserError(
            //   "user",
            //   "Please Allow Camera and Microphone permission"
            // );
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          // navigator.mediaDevices
          //   .getUserMedia({ audio: true, video: true })
          //   .then(
          //     function () {


                navigator.mediaDevices.enumerateDevices().then(
                  function (devices) {
                    let products = [];
                    let deviceIds = [];
                    let deviceIdsAudio = [];
                    let productsAudio = [];

                    devices.forEach(function (device) {
                      console.log("=================================");
                      console.log("devices=>", device);
                      console.log("camera kind ", device.kind);
                      console.log("camera label ", device.label);
                      console.log("camera id ", device.deviceId);
                      console.log("=================================");
                      if (device.kind == "videoinput") {
                        //let temp = {};
                        let temp = { id: device.deviceId, name: device.label };
                        products.push(temp);
                        deviceIds.push(device.deviceId);
                      } else if (device.kind == "audioinput") {
                        let temp = { id: device.deviceId, name: device.label };
                        productsAudio.push(temp);
                        deviceIdsAudio.push(device.deviceId);
                      }

                      // data.push(device.kind + ":*** " + device.label + " id** = " + device.deviceId);
                    });
                    this.products = products;
                    this.deviceIds = deviceIds;
                    this.productsAudio = productsAudio;
                    this.deviceIdsAudio = deviceIdsAudio;

                    console.log(
                      " Devices Ids gotDevices",
                      JSON.stringify(deviceIds)
                    );
                    this.selectedProductId = this.deviceIds[0];
                    this.selectedProductIdAudio = this.deviceIdsAudio[0];
                    this.camera = this.deviceIds[0];
                    this.audio = this.deviceIdsAudio[0];

                    //this.openMediaStream();
                    // this.reportLogMessage({ msg: "UserDevices: " + JSON.stringify(data) });
                  }.bind(this)
                );
        }.bind(this))
            // .catch(
            //   function () {
            //     this.userMessageService.setUserError(
            //       "user",
            //       "Please Allow Camera and Microphone permission"
            //     );
            //   }.bind(this)
            // );
        // }.bind(this)
      // );
  }

  cameraChanged(cameraId) {
    console.log("Camera id switched" + cameraId);

    this.camera = cameraId;
  }

  audioChanged(audioId) {
    console.log("audio id switched" + audioId);

    this.audio = audioId;
  }
}
